import { render } from "./sensor-details.vue?vue&type=template&id=765e7c5a&scoped=true"
import script from "./sensor-details.vue?vue&type=script&lang=js"
export * from "./sensor-details.vue?vue&type=script&lang=js"

import "./sensor-details.vue?vue&type=style&index=0&id=765e7c5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765e7c5a"]])

export default __exports__